import { window } from '@wix/photography-client-lib';
import { useState, useEffect, useMemo } from 'react';
export var useAccessibility = function (isAccessibilityEnabled) {
    var _a = useState(false), isAccessible = _a[0], setAccessibilityState = _a[1];
    var accessibilityHelper = useMemo(function () { return new AccessibilityHelper(setAccessibilityState); }, []);
    useEffect(function () {
        accessibilityHelper.initAccessibility(isAccessibilityEnabled);
        return function () {
            accessibilityHelper.cleanupAccessibility();
        };
    }, []);
    return {
        isAccessible: isAccessible
    };
};
var AccessibilityHelper = /** @class */ (function () {
    function AccessibilityHelper(setAccessibilyState) {
        var _this = this;
        this.waitForFirstTabPress = function (event) {
            if (event.keyCode === 9) {
                event.preventDefault();
                _this.cleanupAccessibility();
                _this.tabWasPressed = true;
                // if (totalItemsCount > 1) { //TODO when we create the native tooltip we will need this here!
                //   loadAccessibilityTooltipComponent();
                // }
                _this.setAccessibilityStateCB(true);
            }
        };
        this.initAccessibility = this.initAccessibility.bind(this);
        this.cleanupAccessibility = this.cleanupAccessibility.bind(this);
        this.waitForFirstTabPress = this.waitForFirstTabPress.bind(this);
        this.tabWasPressed = false;
        this.eventActive = false;
        this.setAccessibilityStateCB = setAccessibilyState;
    }
    AccessibilityHelper.prototype.initAccessibility = function (accessibilityEnabled) {
        if (accessibilityEnabled === void 0) { accessibilityEnabled = true; }
        if (accessibilityEnabled) {
            this.eventActive = true;
            var addEventListener_1 = (window || { addEventListener: function () { } }).addEventListener;
            addEventListener_1('keydown', this.waitForFirstTabPress);
        }
    };
    AccessibilityHelper.prototype.cleanupAccessibility = function () {
        if (this.eventActive) {
            var removeEventListener_1 = (window || { removeEventListener: function () { } }).removeEventListener;
            removeEventListener_1('keydown', this.waitForFirstTabPress);
        }
    };
    return AccessibilityHelper;
}());
export default AccessibilityHelper;
//# sourceMappingURL=nativeAccessibilityHelper.js.map